export enum TicketStatus {
  OPEN = 'OPEN',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_CLIENT = 'WAITING_CLIENT',
  RESOLVED = 'RESOLVED',
  CLOSED = 'CLOSED',
}

export enum TicketPriority {
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
  CRITICAL = 'CRITICAL',
}

export enum TicketCategory {
  SECURITY_INCIDENT = 'SECURITY_INCIDENT',
  FALSE_POSITIVE = 'FALSE_POSITIVE',
  DATA_REQUEST = 'DATA_REQUEST',
  TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',
  FEATURE_REQUEST = 'FEATURE_REQUEST',
  OTHER = 'OTHER',
}

export enum UserRole {
  CLIENT = 'CLIENT',
  ANALYST = 'ANALYST',
  ADMINISTRATOR = 'ADMINISTRATOR',
}

export interface User {
  id: number;
  username: string;
  email: string;
  full_name: string;
  role: UserRole;
  company_id: number;
  is_active: boolean;
  is_superuser: boolean;
}

export interface Company {
  id: number;
  name: string;
}

export interface TicketUser {
  id: number;
  full_name: string;
  email: string;
}

export interface Ticket {
  id: number;
  title: string;
  description: string;
  status: TicketStatus;
  priority: TicketPriority;
  category: TicketCategory;
  created_by_id?: number;
  assigned_to_id?: number;
  company_id?: number;
  created_at: string;
  updated_at?: string;
  resolved_at?: string;
  created_by?: TicketUser;
  assigned_to?: TicketUser;
  company?: Company;
  comments_count?: number;
  attachments?: TicketAttachment[];
}

export interface TicketCommentAuthor {
  id: number;
  full_name: string;
  email: string;
  role?: string;
}

export interface TicketComment {
  id: number;
  ticket_id?: number;
  content: string;
  is_internal: boolean;
  created_at: string;
  updated_at?: string;
  author?: TicketCommentAuthor;
}

export interface TicketAttachment {
  id: number;
  ticket_id: number;
  comment_id?: number | null;
  filename: string;
  content_type?: string | null;
  size?: number | null;
  url: string;
  download_url?: string;
  uploaded_by_id: number;
  created_at: string;
}

export interface CreateTicketRequest {
  title: string;
  description: string;
  priority: TicketPriority;
  category: TicketCategory;
}

export interface UpdateTicketRequest {
  title?: string;
  description?: string;
  status?: TicketStatus;
  priority?: TicketPriority;
  category?: TicketCategory;
  assigned_to_id?: number;
}

export interface CreateCommentRequest {
  content: string;
  is_internal?: boolean;
}

export interface UpdateCommentRequest {
  content?: string;
  is_internal?: boolean;
}

export interface TicketStats {
  total_tickets: number;
  by_status: Record<string, number>;
  by_priority: Record<string, number>;
  by_category: Record<string, number>;
  recent_tickets: number;
  avg_resolution_time?: number;
}

export interface PaginatedTickets {
  tickets: Ticket[];
  total: number;
  page: number;
  per_page: number;
  total_pages: number;
}
